import { render, staticRenderFns } from "./SecshaZone.vue?vue&type=template&id=f2992062&scoped=true"
import script from "./SecshaZone.vue?vue&type=script&lang=js"
export * from "./SecshaZone.vue?vue&type=script&lang=js"
import style0 from "./SecshaZone.vue?vue&type=style&index=0&id=f2992062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2992062",
  null
  
)

export default component.exports